
import BlogWidget from '~/components/blog/BlogWidget.vue'
import 'swiper/css/swiper.min.css'
import Swiper from 'swiper'
export default {
  name: 'BlogPostsCarousel',
  components: {
    BlogWidget,
  },
  props: ['id','posts', 'titleClass', 'target'],
  data() {
    return {
      swiper: null,
    }
  },
  mounted() {
    this.swiper = new Swiper(`#${this.id}.swiper-container`, {
      slidesPerView: 'auto',
      // centeredSlides: true,
      spaceBetween: 10,
      direction: 'vertical',
      navigation: {
        nextEl: `#${this.id} .swiper-button-next`,
        prevEl: `#${this.id} .swiper-button-prev`,
      },
      mousewheel: {
        forceToAxis: true,
        invert: false,
      },
      freeModeSticky: true,
      allowTouchMove: false,
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 2,
          direction: 'horizontal'
        },
        1024: {
          spaceBetween: 30,
          slidesPerView: 2.75,
          direction: 'horizontal'
        },
        1280: {
          spaceBetween: 40,
          slidesPerView: 3.5,
          direction: 'horizontal'
        }
      }
    })
  }
}
